"use client";

import { memo, useEffect, useState } from "react";
import { FaMagnifyingGlassPlus } from "react-icons/fa6";

import { PdfView } from "components";
import { cn } from "utils/cn";
import { getMimeType } from "utils/fileType.util";

const FileFrame = memo(
  ({
    src,
    size,
    isHidePlusButton,
    className,
    emptyClassName,
    wrapperClassName,
  }: {
    src?: string;
    size?: number;
    isHidePlusButton?: boolean;
    className?: string;
    emptyClassName?: string;
    wrapperClassName?: string;
  }) => {
    // srcのMIMEタイプを取得する
    const [previewUrlSrcType, setPreviewUrlSrcType] = useState<
      "application/pdf" | "image/jpeg" | "image/png" | undefined
    >(undefined);

    useEffect(() => {
      if (src) {
        if (src.toUpperCase().includes(".PDF")) {
          setPreviewUrlSrcType("application/pdf");
          return;
        }

        getMimeType(src, (type) => {
          setPreviewUrlSrcType(type);
        });
      }
    }, [src]);
    
    if (src == null)
      return <div className={cn("h-[120px] w-[120px] border border-text-gray", className, emptyClassName)}></div>;

    const boxStyle = size === undefined ? " h-[120px] w-[120px]" : ` h-[${size}px] w-[${size}px] `;
    const onClickFrame = () => {
      window.open(src, "_blank");
    };

    return (
      <div className={cn("relative cursor-pointer py-2", wrapperClassName)} onClick={onClickFrame}>
        {previewUrlSrcType === "application/pdf" ? (
          <div
            className={cn(
              `pointer-events-none flex items-center justify-center overflow-hidden border border-text-gray object-cover ${boxStyle}`,
              className
            )}
          >
            <PdfView src={src} size={120} />
          </div>
        ) : (
          <img
            src={src}
            alt="document_file"
            className={cn(`pointer-events-none overflow-hidden border border-text-gray object-cover`, className)}
            style={{ width: `${size || 120}px`, height: `${size || 120}px` }}
          />
        )}

        {!isHidePlusButton && (
          <FaMagnifyingGlassPlus className="absolute bottom-2 right-0 h-[26px] w-[26px] bg-white p-[6px] text-gray" />
        )}
      </div>
    );
  }
);

FileFrame.displayName = "FileFrame";

export default FileFrame;
